import React from 'react';

// eslint-disable-next-line no-unused-vars
import Chart from './Chart.bundle.js';

import { _init, _setDistance, _setContact, _setTilt, _setRotation, _clearChart } from '../html/TreatmentQualityChart/TreatmentQualityChart.js'

class MagstimTreatmentQualityChart extends React.Component {

    constructor() {
        super();
        this._canvasRef = React.createRef();

    }

    componentWillUnmount() {
        _clearChart(this.props.chartCanvasName);
    }

    init(fontSize) {
        _init(this.props.chartCanvasName, fontSize);
    }

    setDistance(value) {
        _setDistance(this.props.chartCanvasName, value);
    }

    setContact(value) {
        _setContact(this.props.chartCanvasName, value);
    }

    setTilt(value) {
        _setTilt(this.props.chartCanvasName, value);
    }

    setRotation(value) {
        _setRotation(this.props.chartCanvasName, value);
    }

    reset(){ 
        _setDistance(this.props.chartCanvasName, 0);
        _setContact(this.props.chartCanvasName, 0);
        _setTilt(this.props.chartCanvasName, 0);
        _setRotation(this.props.chartCanvasName, 0);
    }

    render() {
        var content = <div className={"ui-panel d-block pt-3"} >
            <canvas style={{ width: this.props.width, height: this.props.height }} ref={this._canvasRef} id={this.props.chartCanvasName} />
        </div>;

        return (
            <>
                {content}
            </>
        );
    }
}

export default MagstimTreatmentQualityChart;